export enum Breakpoint {
  SM = 'screen and (max-width: 767px)',
  GT_SM = 'screen and (min-width: 767px)',
  MD = 'screen and (min-width: 767px) and (max-width: 1023px)',
  GT_MD = 'screen and (min-width: 1023px)',
  LG = 'screen and (min-width: 1023px) and (max-width: 1365px)',
  GT_LG = 'screen and (min-width: 1365px)',
  LT_LG = 'screen and (max-width: 1365px)',
  LT_MD = 'screen and (max-width: 1023px)'
}

export interface BreakpointState {
  matches: boolean;
  breakpoints: Record<string, boolean>;
  isBreakpointMatch(breakpoint: Breakpoint): boolean;
}

